import { FailureResponseShape, isBody } from 'src/common/actions/request/types';

/*
 * Whether a refused request came back with a particular Stardog error code. A
 * request that never reached the server has no body, and so no code to match.
 */
export const hasStardogErrorCode = (
  response: FailureResponseShape,
  code: string
) => isBody(response) && response.body?.code === code;
